import { I_ApprovalStatusCounts } from "../interfaces";

const approvalStatusCountBoilerplate: I_ApprovalStatusCounts[] = [];

export default approvalStatusCountBoilerplate